import React, { forwardRef } from 'react';
import EmbeddedVimeo, { Props as VideoEmbeddedProps, VIMEO_DEFAULT_PARAMS } from 'src/components/EmbeddedVimeo';
import EmbeddedYoutube, { YOUTUBE_DEFAULT_PARAMS } from 'src/components/EmbeddedYoutube';
import { isYoutubeVideo } from 'src/helpers';

type Props = {
  videoId: string | number;
  videoConfig?: Omit<VideoEmbeddedProps, 'vimeoId'>;
};

export function getDefaultVideoConfig(videoId: string | number) {
  return isYoutubeVideo(videoId) ? YOUTUBE_DEFAULT_PARAMS : VIMEO_DEFAULT_PARAMS
}

const EmbeddedVideo = forwardRef<HTMLIFrameElement | null, Props>(
  ({ videoId, videoConfig = {} }, ref) => {
    return isYoutubeVideo(videoId) ? (
      <EmbeddedYoutube
        ref={ref}
        youtubeId={String(videoId)}
        {...{
          ...videoConfig,
        }}
      />
    ) : (
      <EmbeddedVimeo
        ref={ref}
        vimeoId={String(videoId)}
        {...{
          ...videoConfig,
        }}
      />
    );
  }
);

EmbeddedVideo.displayName = 'EmbeddedVideo';

export default EmbeddedVideo;
